import type {SyntheticEvent} from 'react'
import {useState} from 'react'
import {HttpError} from '@freckle/educator-entities/ts/common/exceptions/http-error'
import type {LangT} from '@freckle/educator-entities/ts/common/helpers/languages'
import type {RlStandardSetT} from '@freckle/educator-entities/ts/common/models/rl-standard-set'
import {logErrorAsUnhandled} from '@freckle/school/ts/common/helpers/exception-handlers/bugsnag-client'
import Notification from '@freckle/school/ts/common/helpers/notification'
import SettingsComponent from '@freckle/school/ts/settings/components/settings'
import type {SchoolAdminAttrs} from '@freckle/school/ts/users/models/school-admin'
import {patchSchoolAdmin} from '@freckle/school/ts/users/models/school-admin'

type Props = {
  mathStandardSets: Array<RlStandardSetT>
  schoolAdmin: SchoolAdminAttrs
}

export function SettingsComponentContainer(props: Props) {
  const {mathStandardSets, schoolAdmin} = props

  const [selectedMathStandardSetId, setSelectedMathStandardSetId] = useState<
    string | null | undefined
  >(schoolAdmin.mathStandardSet.id)

  const [selectedLanguage, setSelectedLanguage] = useState<LangT>(schoolAdmin.language)

  function onSubmit(e: SyntheticEvent<EventTarget, Event>): Promise<unknown> {
    e.preventDefault()

    return patchSchoolAdmin({
      mathStandardSetId: selectedMathStandardSetId,
      language: selectedLanguage,
    }).then(
      () => {
        Notification.displaySuccessNotification('Updated successfully, reloading...', 1.0, () => {
          window.location.reload()
        })
      },
      error => {
        logErrorAsUnhandled(new HttpError(error))
        Notification.displayErrorNotification('Could not update. Please try again')
      },
    )
  }

  return (
    <SettingsComponent
      mathStandardSets={mathStandardSets}
      schoolAdmin={schoolAdmin}
      selectedMathStandardSetId={selectedMathStandardSetId}
      selectedLanguage={selectedLanguage}
      onSubmit={onSubmit}
      onChangeMathStandardSetId={s => {
        setSelectedMathStandardSetId(s)
      }}
      onChangeLanguage={s => {
        setSelectedLanguage(s)
      }}
    />
  )
}
